import * as React from "react"
export const WorldWideUsers = () => {
  return (
    <div className="container mx-auto">
      <div className="flex overflow-hidden lg:mx-1 mx-4 justify-between mt-14">
        {/* <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="68"
            height="65"
            viewBox="0 0 68 65"
            fill="none"
          >
            <rect
              y="0.965332"
              width="67.4478"
              height="64"
              fill="url(#pattern0_329_446)"
            />
            <defs>
              <pattern
                id="pattern0_329_446"
                patternContentUnits="objectBoundingBox"
                width="1"
                height="1"
              >
                <use
                  xlinkHref="#image0_329_446"
                  transform="scale(0.00319489 0.003367)"
                />
              </pattern>
              <image id="image0_329_446" width="313" height="297" />
            </defs>
          </svg>
        </div> */}
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 66 65"
            fill="none"
          >
            <rect
              x="3.94727"
              y="4.46533"
              width="58.3592"
              height="57"
              stroke="#B3B3B3"
              strokeWidth="7"
            />
            <rect
              x="15.1504"
              y="15.3945"
              width="35.9518"
              height="35.1417"
              stroke="#B3B3B3"
              strokeWidth="3"
            />
            <rect
              x="25.6699"
              y="25.6953"
              width="14.9128"
              height="14.5402"
              stroke="#B3B3B3"
              strokeWidth="3"
            />
            <rect
              x="27.8438"
              y="27.8232"
              width="10.5662"
              height="10.2841"
              stroke="#B3B3B3"
              strokeWidth="3"
            />
            <rect
              x="30.3809"
              y="30.3071"
              width="5.49281"
              height="5.31619"
              stroke="#B3B3B3"
              strokeWidth="3"
            />
          </svg>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 50 65"
            fill="none"
          >
            <path
              d="M7.51751 35.3166L25.0408 4.96533L42.5641 35.3166H7.51751Z"
              stroke="#B3B3B3"
              strokeWidth="4"
            />
            <path
              d="M7.51751 50.8483L25.0408 20.4971L42.5641 50.8483H7.51751Z"
              stroke="#B3B3B3"
              strokeWidth="4"
            />
          </svg>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 61 65"
            fill="none"
          >
            <circle
              cx="41.9197"
              cy="42.6087"
              r="17.7088"
              stroke="#B3B3B3"
              strokeWidth="2"
            />
            <circle
              cx="30.3104"
              cy="29.7259"
              r="18.1532"
              stroke="#B3B3B3"
              strokeWidth="1.11128"
            />
            <circle
              cx="20.9666"
              cy="46.2567"
              r="16.2088"
              stroke="#B3B3B3"
              strokeWidth="5"
            />
            <circle
              cx="18.9842"
              cy="19.6741"
              r="16.7088"
              stroke="#B3B3B3"
              strokeWidth="4"
            />
            <circle
              cx="41.9197"
              cy="19.6741"
              r="17.2088"
              stroke="#B3B3B3"
              strokeWidth="3"
            />
          </svg>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 67 65"
            fill="none"
          >
            <rect
              x="0.626953"
              y="0.965332"
              width="65.9653"
              height="1.96876"
              fill="#B3B3B3"
            />
            <rect
              x="0.626953"
              y="7.16846"
              width="65.9653"
              height="1.96876"
              fill="#B3B3B3"
            />
            <rect
              x="0.626953"
              y="13.3716"
              width="65.9653"
              height="1.96876"
              fill="#B3B3B3"
            />
            <rect
              x="0.626953"
              y="19.5747"
              width="65.9653"
              height="1.96876"
              fill="#B3B3B3"
            />
            <rect
              x="0.626953"
              y="25.7778"
              width="65.9653"
              height="1.96876"
              fill="#B3B3B3"
            />
            <rect
              x="0.626953"
              y="31.981"
              width="65.9653"
              height="1.96876"
              fill="#B3B3B3"
            />
            <rect
              x="0.626953"
              y="38.1841"
              width="65.9653"
              height="1.96876"
              fill="#B3B3B3"
            />
            <rect
              x="0.626953"
              y="44.3872"
              width="65.9653"
              height="1.96876"
              fill="#B3B3B3"
            />
            <rect
              x="0.626953"
              y="50.5903"
              width="65.9653"
              height="1.96876"
              fill="#B3B3B3"
            />
            <rect
              x="0.626953"
              y="56.7935"
              width="65.9653"
              height="1.96876"
              fill="#B3B3B3"
            />
            <rect
              x="0.626953"
              y="62.9966"
              width="65.9653"
              height="1.96876"
              fill="#B3B3B3"
            />
          </svg>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 65 65"
            fill="none"
          >
            <circle
              cx="32.5938"
              cy="32.9653"
              r="28"
              stroke="#B3B3B3"
              strokeWidth="8"
            />
            <circle
              cx="32.5938"
              cy="32.9654"
              r="14.7813"
              stroke="#B3B3B3"
              strokeWidth="8"
            />
            <circle
              cx="32.5943"
              cy="32.9654"
              r="4"
              stroke="#B3B3B3"
              strokeWidth="0.645556"
            />
          </svg>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 66 65"
            fill="none"
          >
            <mask
              id="mask0_329_478"
              mask-type="alph"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="66"
              height="65"
            >
              <rect
                x="0.59375"
                y="0.965332"
                width="65.3592"
                height="64"
                fill="#C4C4C4"
              />
            </mask>
            <g mask="url(#mask0_329_478)">
              <rect
                x="34.3867"
                y="-15.3369"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 34.3867 -15.3369)"
                fill="#B3B3B3"
              />
              <rect
                x="31.9102"
                y="-12.8604"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 31.9102 -12.8604)"
                fill="#B3B3B3"
              />
              <rect
                x="29.4336"
                y="-10.3838"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 29.4336 -10.3838)"
                fill="#B3B3B3"
              />
              <rect
                x="26.959"
                y="-7.90723"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 26.959 -7.90723)"
                fill="#B3B3B3"
              />
              <rect
                x="24.4824"
                y="-5.43311"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 24.4824 -5.43311)"
                fill="#B3B3B3"
              />
              <rect
                x="22.0059"
                y="-2.95654"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 22.0059 -2.95654)"
                fill="#B3B3B3"
              />
              <rect
                x="19.5293"
                y="-0.47998"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 19.5293 -0.47998)"
                fill="#B3B3B3"
              />
              <rect
                x="17.0527"
                y="1.99658"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 17.0527 1.99658)"
                fill="#B3B3B3"
              />
              <rect
                x="14.5781"
                y="4.47314"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 14.5781 4.47314)"
                fill="#B3B3B3"
              />
              <rect
                x="12.1016"
                y="6.94971"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 12.1016 6.94971)"
                fill="#B3B3B3"
              />
              <rect
                x="9.625"
                y="9.42627"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 9.625 9.42627)"
                fill="#B3B3B3"
              />
              <rect
                x="7.12695"
                y="12.2207"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 7.12695 12.2207)"
                fill="#B3B3B3"
              />
              <rect
                x="4.65234"
                y="14.6973"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 4.65234 14.6973)"
                fill="#B3B3B3"
              />
              <rect
                x="2.17578"
                y="17.1738"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 2.17578 17.1738)"
                fill="#B3B3B3"
              />
              <rect
                x="-0.300781"
                y="19.6504"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 -0.300781 19.6504)"
                fill="#B3B3B3"
              />
              <rect
                x="-2.77734"
                y="22.127"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 -2.77734 22.127)"
                fill="#B3B3B3"
              />
              <rect
                x="-5.25391"
                y="24.6035"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 -5.25391 24.6035)"
                fill="#B3B3B3"
              />
              <rect
                x="-7.73047"
                y="27.0776"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 -7.73047 27.0776)"
                fill="#B3B3B3"
              />
              <rect
                x="-10.207"
                y="29.5542"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 -10.207 29.5542)"
                fill="#B3B3B3"
              />
              <rect
                x="-12.6836"
                y="32.0308"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 -12.6836 32.0308)"
                fill="#B3B3B3"
              />
              <rect
                x="-15.1602"
                y="34.5073"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 -15.1602 34.5073)"
                fill="#B3B3B3"
              />
              <rect
                x="-17.6348"
                y="36.9839"
                width="65.3592"
                height="1.95067"
                transform="rotate(45 -17.6348 36.9839)"
                fill="#B3B3B3"
              />
            </g>
          </svg>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 67 65"
            fill="none"
          >
            <path
              d="M38.9172 18.0447L47.5314 15.7365L56.1456 18.0447L62.4517 24.3507L64.7599 32.965L62.4517 41.5792L56.1456 47.8853L47.5314 50.1935L38.9172 47.8853L32.6111 41.5792L30.3029 32.965L32.6111 24.3507L38.9172 18.0447Z"
              stroke="#B3B3B3"
              strokeWidth="3"
            />
            <path
              d="M25.2775 5.27422L33.633 3.0354L41.9884 5.27422L48.105 11.3908L50.3438 19.7462L48.105 28.1017L41.9884 34.2183L33.633 36.4571L25.2775 34.2183L19.1609 28.1017L16.9221 19.7462L19.1609 11.3908L25.2775 5.27422Z"
              stroke="#B3B3B3"
              strokeWidth="4"
            />
            <path
              d="M10.8615 17.5964L19.7345 15.2189L28.6076 17.5964L35.1031 24.0919L37.4806 32.965L35.1031 41.8381L28.6076 48.3336L19.7345 50.7111L10.8615 48.3336L4.36593 41.8381L1.9884 32.965L4.36593 24.0919L10.8615 17.5964Z"
              stroke="#B3B3B3"
              strokeWidth="2"
            />
            <path
              d="M24.5011 30.3669L33.633 27.92L42.7648 30.3669L49.4498 37.0519L51.8967 46.1837L49.4498 55.3156L42.7648 62.0006L33.633 64.4475L24.5011 62.0006L17.8161 55.3156L15.3692 46.1837L17.8161 37.0519L24.5011 30.3669Z"
              stroke="#B3B3B3"
            />
          </svg>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 66 65"
            fill="none"
          >
            <rect
              x="1.3125"
              y="1.96582"
              width="29.0756"
              height="28.4293"
              stroke="#B3B3B3"
              strokeWidth="2"
            />
            <rect
              x="12.8125"
              y="13.1558"
              width="29.0756"
              height="28.4293"
              stroke="#B3B3B3"
              strokeWidth="2"
            />
            <rect
              x="24.3105"
              y="24.3462"
              width="29.0756"
              height="28.4293"
              stroke="#B3B3B3"
              strokeWidth="2"
            />
            <rect
              x="35.8105"
              y="35.5361"
              width="29.0756"
              height="28.4293"
              stroke="#B3B3B3"
              strokeWidth="2"
            />
          </svg>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 65 66"
            fill="none"
          >
            <rect
              x="0.884766"
              y="56.5254"
              width="28.5163"
              height="1.96876"
              transform="rotate(-90 0.884766 56.5254)"
              fill="#B3B3B3"
            />
            <rect
              x="7.08789"
              y="65.9653"
              width="65.9653"
              height="1.96876"
              transform="rotate(-90 7.08789 65.9653)"
              fill="#B3B3B3"
            />
            <rect
              x="13.291"
              y="56.5254"
              width="28.5163"
              height="1.96876"
              transform="rotate(-90 13.291 56.5254)"
              fill="#B3B3B3"
            />
            <rect
              x="19.4941"
              y="65.9653"
              width="65.9653"
              height="1.96876"
              transform="rotate(-90 19.4941 65.9653)"
              fill="#B3B3B3"
            />
            <rect
              x="25.6973"
              y="56.5254"
              width="28.5163"
              height="1.96876"
              transform="rotate(-90 25.6973 56.5254)"
              fill="#B3B3B3"
            />
            <rect
              x="31.9004"
              y="65.9653"
              width="65.9653"
              height="1.96876"
              transform="rotate(-90 31.9004 65.9653)"
              fill="#B3B3B3"
            />
            <rect
              x="38.1035"
              y="56.5254"
              width="28.5163"
              height="1.96876"
              transform="rotate(-90 38.1035 56.5254)"
              fill="#B3B3B3"
            />
            <rect
              x="44.3066"
              y="65.9653"
              width="65.9653"
              height="1.96876"
              transform="rotate(-90 44.3066 65.9653)"
              fill="#B3B3B3"
            />
            <rect
              x="50.5098"
              y="56.5254"
              width="28.5163"
              height="1.96876"
              transform="rotate(-90 50.5098 56.5254)"
              fill="#B3B3B3"
            />
            <rect
              x="56.7129"
              y="65.9653"
              width="65.9653"
              height="1.96876"
              transform="rotate(-90 56.7129 65.9653)"
              fill="#B3B3B3"
            />
            <rect
              x="62.916"
              y="56.5254"
              width="28.5163"
              height="1.96876"
              transform="rotate(-90 62.916 56.5254)"
              fill="#B3B3B3"
            />
          </svg>
        </div>
      </div>
      <div className="text-gray text-center text-sm mt-5 ">
        <p>
          used by over 3000+ users worldwide and trusted by top-tier companies.
        </p>
      </div>
    </div>
  )
}
